import { render, staticRenderFns } from "./workflowDesigner2.vue?vue&type=template&id=34b05edc&"
import script from "./workflowDesigner2.vue?vue&type=script&lang=js&"
export * from "./workflowDesigner2.vue?vue&type=script&lang=js&"
import style0 from "./workflowDesigner2.vue?vue&type=style&index=0&id=34b05edc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports